import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { ADMINISTRATOR_OPTIONS } from '@/pages/instruments/new-instrument/constants/administrators'

export interface AdministratorFormFieldProps {}

export const AdministratorFormField: React.FC<AdministratorFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ administrator: string | null }>()

  return (
    <FormField
      name="administrator"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Administrator</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              showNone={'None'}
              value={value?.toString()}
              setValue={(value) =>
                setValue('administrator', value ? value : null, { shouldValidate: true })
              }
              className={'min-w-auto'}
              placeholder={'Select an adnimistrator...'}
              options={ADMINISTRATOR_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
